import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NbMenuModule, 
  NbDialogModule, 
  NbTabsetModule,
  NbAccordionModule,
  NbCardModule,
  NbSelectModule,
  NbToggleModule,
  NbIconModule,
  NbButtonModule,
  NbContextMenuModule,
  NbCheckboxModule,
  NbAlertModule,
  NbSpinnerModule,
  NbListModule,
  NbStepperModule,
  NbRadioModule } from '@nebular/theme';
import { ThemeModule } from '../@theme/theme.module';

import { QuillModule } from 'ngx-quill';

import { DialogComponent } from './dialog/dialog.component';

import { GoogleMapsModule } from '@angular/google-maps';

import { TableModule } from 'ngx-easy-table';

import { TableComponent } from './table/table.component';
import { SearchComponent } from './search/search.component';
import { QuillEditorComponent } from './editor/quill/quill.component';
import { MultilangEditorComponent } from '../components/editor/multilang-editor.component';
import { MultilangEditModalComponent } from '../components/editor/multilang-edit-modal.component';

import { BlockEditorComponent } from '../components/editor/block-editor/block-editor.component';
import { BlockEditModalComponent } from '../components/editor/block-editor/block-edit-modal.component';
import { EditorDialogComponent } from '../components/editor/block-editor/components/editor-dialog.component';
import { EditorMediaComponent } from '../components/editor/block-editor/components/editor-media.component';
import { BlockViewerComponent } from '../components/editor/block-editor/viewer/block-viewer.component';
import { DialogViewerComponent } from '../components/editor/block-editor/viewer/dialog-viewer.component';
import { MediaViewerComponent } from '../components/editor/block-editor/viewer/media-viewer.component';
import { MediaLibComponent } from '../components/medias/library/media-lib.component';
import { VoiceEditorComponent } from '../components/voice/voice-editor.component';

import { MediaSelectorComponent } from '../components/medias/media-selector.component';
import { SelectMediaModalComponent } from '../components/medias/library/select-media-modal.component';

import { ImportMissionTemplateComponent } from '../components/import-mission-template/import-mission-template.component';
import { ImportOpenMissionTemplateComponent } from '../components/import-open-mission/import-open-mission.component';
import { GameMenuComponent } from '../pages/game/menu/game-menu.component';
import { TemplateMenuComponent } from '../pages/template/menu/template-menu.component';
import { ConfirmModalComponent } from './modals/confirm-modal.component';
import { AlertModalComponent } from './modals/alert-modal.component';
import { TemplateUpdateModalComponent } from './template-update/template-update-modal.component';
import { LangDiffComponent } from '../components/template-update/lang-diff/lang-diff.component';

import { EditMissionComponent } from '../components/edit-mission/edit-mission.component';
import { EditMissionParamsComponent } from '../components/edit-mission-param/edit-mission-param.component';
import { EditMissionReferencesComponent } from '../components/edit-mission-references/edit-mission-references.component';
import { ParameterMissionComponent } from '../components/parameter-mission/parameter-mission.component';
import { MissionPreviewComponent } from '../components/mission-preview/mission-preview.component';

import { QuizzComponent } from '../components/quizz/quizz.component';

import { ObjectEditModalComponent } from '../components/edit-object/object-edit-modal.component';
import { EditObjectsComponent } from '../components/objects/edit-objects.component';
import { EditResourcesComponent } from '../components/resources/edit-resources.component';
import { ResourceEditModalComponent } from '../components/resources/edit/resource-edit-modal.component';
import { ResourceSelectorComponent } from '../components/resources/resource-selector.component';
import { EditBuildingsComponent } from '../components/buildings/edit-buildings.component';
import { BuildingEditModalComponent } from '../components/buildings/edit/building-edit-modal.component';
import { EditRolesComponent } from '../components/roles/edit-roles.component';
import { RoleEditModalComponent } from '../components/roles/edit/role-edit-modal.component';
import { EditCharactersComponent } from '../components/characters/edit-characters.component';
import { CharacterEditModalComponent } from '../components/characters/edit/character-edit-modal.component';
import { ObjectChangesModalComponent } from '../components/object-changes/object-changes-modal.component';
import { CharacterChangesModalComponent } from '../components/characters/changes/character-changes-modal.component';
import { RoleChangesModalComponent } from '../components/roles/changes/role-changes-modal.component';
import { DropdownComponent } from '../components/dropdown/dropdown.component';

import { ChatGPTModalComponent } from './ai/chatgpt-modal.component';



@NgModule({
    imports: [
        ThemeModule,
        TableModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        QuillModule,
        NbDialogModule.forChild(),
        NbTabsetModule,
        NbAccordionModule,
        NbMenuModule,
        NbCardModule,
        NbSelectModule,
        NbToggleModule,
        NbIconModule,
        NbButtonModule,
        NbContextMenuModule,
        NbCheckboxModule,
        NbAlertModule,
        NbSpinnerModule,
        NbListModule,
        DragDropModule,
        GoogleMapsModule,
        NbStepperModule,
        NbRadioModule
    ],
    declarations: [
        TemplateMenuComponent,
        GameMenuComponent,
        DialogComponent,
        ConfirmModalComponent,
        AlertModalComponent,
        TemplateUpdateModalComponent,
        LangDiffComponent,
        EditMissionComponent,
        ParameterMissionComponent,
        EditMissionParamsComponent,
        EditMissionReferencesComponent,
        MissionPreviewComponent,
        QuizzComponent,
        ObjectEditModalComponent,
        EditObjectsComponent,
        EditResourcesComponent,
        ResourceEditModalComponent,
        ResourceSelectorComponent,
        EditBuildingsComponent,
        BuildingEditModalComponent,
        EditRolesComponent,
        RoleEditModalComponent,
        EditCharactersComponent,
        CharacterEditModalComponent,
        ObjectChangesModalComponent,
        CharacterChangesModalComponent,
        RoleChangesModalComponent,
        QuillEditorComponent,
        MultilangEditorComponent,
        MultilangEditModalComponent,
        BlockEditorComponent,
        BlockEditModalComponent,
        EditorDialogComponent,
        EditorMediaComponent,
        BlockViewerComponent,
        DialogViewerComponent,
        MediaLibComponent,
        VoiceEditorComponent,
        MediaViewerComponent,
        MediaSelectorComponent,
        SelectMediaModalComponent,
        ImportMissionTemplateComponent,
        SearchComponent,
        TableComponent,
        DropdownComponent,
        ImportOpenMissionTemplateComponent,
        ChatGPTModalComponent
    ],
    exports: [
        TemplateMenuComponent,
        GameMenuComponent,
        DialogComponent,
        EditMissionComponent,
        EditMissionParamsComponent,
        EditMissionReferencesComponent,
        ParameterMissionComponent,
        MissionPreviewComponent,
        MultilangEditorComponent,
        BlockEditorComponent,
        EditorDialogComponent,
        EditorMediaComponent,
        BlockViewerComponent,
        DialogViewerComponent,
        MediaLibComponent,
        VoiceEditorComponent,
        MediaViewerComponent,
        MediaSelectorComponent,
        LangDiffComponent,
        SearchComponent,
        TableComponent,
        DropdownComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {
}
